/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Badge } from 'react-bootstrap'; // eslint-disable-next-line
import { copiriAxiosPost, convertArrayObjectsToArray } from '../../api/api'; // eslint-disable-next-line
import config from '../../config/config'; // eslint-disable-next-line
import CopiriLoader from '../../common/CopiriLoader'; // eslint-disable-next-line
import img_1 from '../../../assets/img/lodges/img_1.png'; // eslint-disable-next-line
import img_2 from '../../../assets/img/lodges/img_2.png'; // eslint-disable-next-line
import img_3 from '../../../assets/img/lodges/img_3.png'; // eslint-disable-next-line
import img_4 from '../../../assets/img/lodges/img_4.png'; // eslint-disable-next-line
import LodgeManageImagesModal from './LodgeManageImagesModal'; // eslint-disable-next-line
import org_image from '../../../assets/img/logos/no_gl_seal_light.png';
const LodgeModalImageSection = props => {
	// eslint-disable-next-line
	const { lodgeData, pageLanguageContent, updateLodgeModal, lodgeImages } = props;
	const [showHideImageModal, setShowHideImageModal] = useState(false);
	const [lodgeImagesData, setLodgeImagesData] = useState([]);
	useEffect(() => {
		checkImgArr(lodgeImages);
	}, [lodgeImages]);

	/* function to show lodge images modal */
	const openManageImagesModal = () => {
		setShowHideImageModal(true);
	};
	/* function to hide lodge images modal */
	const closeManageImagesModal = () => {
		setShowHideImageModal(false);
	};

	/* callback function to update the images */
	function callBackImagesData(imagesData) {
		setLodgeImagesData(convertArrayObjectsToArray(imagesData));
	}
	/* function to convert array object to one dimensional array*/
	function checkImgArr(imgArr) {
		setLodgeImagesData([]);
		if (imgArr.length > 0) {
			let c = convertArrayObjectsToArray(imgArr);
			setLodgeImagesData(c);
		}
	}
	return (
		<>
			<Row className='lodges-bottom-footer lodge-social-links'>
				<Col lg={12} className='mt-2'>
					<h4>{pageLanguageContent['CLD143'] ? pageLanguageContent['CLD143'] : ''}</h4>
					<hr />
				</Col>
				<ul>
					{lodgeImagesData &&
						lodgeImagesData.length > 0 &&
						lodgeImagesData.map((item, i) => (
							<span key={i}>
								{i < 5 && (
									<>
										<li onClick={() => openManageImagesModal()}>
											<img src={item} onError={e => (e.target.src = org_image)} alt={''} />
										</li>
									</>
								)}
							</span>
						))}

					{lodgeImagesData && lodgeImagesData.length >= 5 && (
						<li>
							<div className='btn-img-lodge'>
								<Button
									className='btn-lodge-vl btn btn-none'
									variant='outline-primary'
									bg=''
									onClick={() => openManageImagesModal()}
								>
									{pageLanguageContent['CLD129'] ? pageLanguageContent['CLD129'] : ''}
								</Button>
							</div>
						</li>
					)}
					{lodgeImagesData && lodgeImagesData.length > 0 && (
						<li className='ml-auto'>
							<div className='btns-org'>
								<Badge bg={''} className='mr-1 badge-soft-info'>
									<i className='far fa-edit' onClick={() => openManageImagesModal()}></i>
								</Badge>
							</div>
						</li>
					)}

					{lodgeImagesData && lodgeImagesData.length <= 0 && (
						<li>
							<div className='btn-img-lodge'>
								<Button
									className='btn-lodge-vl btn btn-none'
									variant='outline-primary'
									bg=''
									onClick={() => openManageImagesModal()}
								>
									{pageLanguageContent['CLD011'] ? pageLanguageContent['CLD011'] : ''}
								</Button>
							</div>
						</li>
					)}
				</ul>
			</Row>
			<LodgeManageImagesModal
				showHide={showHideImageModal}
				closeModal={closeManageImagesModal}
				lodgeImages={lodgeImagesData}
				pageLanguageContent={pageLanguageContent}
				lodgeData={lodgeData}
				updateLodgeModal={updateLodgeModal}
				callBackImagesData={callBackImagesData}
			/>
		</>
	);
};
export default LodgeModalImageSection;
